<script setup lang="ts">
    import { ref, useSlots, watch } from 'vue';
    import { ChevronDownIcon } from '@lucide/vue';

    const props = defineProps<{
        /** Expands the section when it turns true, but never collapses it: the user stays in control. */
        open?: boolean;
    }>();

    const slots = useSlots();
    const hasIcon = !!slots.icon;

    const details = ref<HTMLDetailsElement>();

    watch([() => props.open, details], ([open, element]) => {
        if (!open || !element) return;
        element.open = true;
    });
</script>
<template>
    <details v-if="hasIcon" ref="details">
        <summary class="custom-focus block">
            <span class="flex items-center">
                <span class="-ml-0.5 mr-1.5 size-5 inline-flex items-center justify-center">
                    <slot name="icon" />
                </span>
                <slot />
            </span>

            <ChevronDownIcon class="size-5 -my-0.5 -mx-2 absolute top-3 right-4" />
        </summary>

        <slot name="content" />
    </details>
    <template v-else>
        <slot name="content" />
    </template>
</template>
